import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import {
  Marker,
  APIProvider,
  Map as GoogleMap,
} from '@vis.gl/react-google-maps'

import { generatePath, replacePhoneNumber } from '@/utils'
import { useLanguages } from '@/hooks'
import { IPageDetail } from '@/types'
import { Link } from '@/i18n'

import { Services } from './services'

interface ILocationDetailsProps extends IPageDetail {
  location: string
}

export const LocationDetailsView: React.FC<ILocationDetailsProps> = ({
  email,
  address,
  location,
  latitude,
  longitude,
  description,
  phone_number,
  working_hours,
  // days_and_hours,
  other_information,
}) => {
  const { t } = useLanguages()
  const [show, setShow] = useState(false)

  useEffect(() => {
    setShow(false)
  }, [location])

  return (
    <section className="location_wrapper theme--dark-blue">
      <div className="row">
        <div className="column small-12">
          <div
            className="white-color"
            dangerouslySetInnerHTML={{ __html: description }}
          />
          <Link
            target="_blank"
            className="yellow-color"
            href={generatePath(process.env.NEXT_PUBLIC_GOOGLE_MAP_PATH ?? '', {
              lat: latitude,
              lng: longitude,
            })}
          >
            {t('getDirections')}
          </Link>
        </div>
        <div className="column small-12 medium-6">
          <div>
            <GoogleMap
              zoomControl
              defaultZoom={11}
              fullscreenControl
              mapId="custom-map-id"
              disableDefaultUI={false}
              defaultCenter={{
                // @ts-ignore
                lat: +latitude,
                // @ts-ignore
                lng: +longitude,
              }}
              zoomControlOptions={{ position: 9 }}
              style={{ height: '300px' }}
            >
              <Marker
                position={{
                  // @ts-ignore
                  lat: +latitude,
                  // @ts-ignore
                  lng: +longitude,
                }}
              />
            </GoogleMap>
          </div>
        </div>
        <div className="column small-12 medium-6">
          <div>
            <div className="branch-location-detail">
              <Link
                href={generatePath(
                  process.env.NEXT_PUBLIC_GOOGLE_MAP_PATH ?? '',
                  {
                    lat: latitude,
                    lng: longitude,
                  },
                )}
                className="flex-container align-middle align-justify"
              >
                <div className="branch-location-detail-left flex-container align-middle">
                  <i className="location--icon"></i>
                  <span>{address}</span>
                </div>
                <i className="icon--external-link detail-icon"></i>
              </Link>
            </div>
            {!!phone_number && (
              <div className="branch-location-detail">
                <Link
                  href={`tel:${replacePhoneNumber(phone_number)}`}
                  className="flex-container align-middle align-justify"
                >
                  <div className="branch-location-detail-left flex-container align-middle">
                    <i className="phone--icon"></i>
                    <span>{replacePhoneNumber(phone_number)}</span>
                  </div>
                  <i className="icon--external-link detail-icon"></i>
                </Link>
              </div>
            )}
            <div className="branch-location-detail">
              <div
                onClick={() => setShow(prev => !prev)}
                className="flex-container align-middle align-justify"
              >
                <div className="branch-location-detail-left flex-container align-middle">
                  <i className="time--icon"></i>
                  <span>{t('todaysHours')}</span>
                </div>
                <i className="icon--toggler detail-icon"></i>
              </div>
              <div
                className={classNames('location_hide_info', {
                  show,
                })}
              >
                {/* {!!days_and_hours && (
                  <div
                    className="flex-container align-middle align-justify"
                    dangerouslySetInnerHTML={{ __html: days_and_hours }}
                  />
                )} */}
                {!!working_hours && (
                  <div
                    className="flex-container align-start align-justify flex-column"
                    dangerouslySetInnerHTML={{ __html: working_hours }}
                  />
                )}
                {!!other_information && (
                  <div
                    className="flex-container align-middle align-justify"
                    dangerouslySetInnerHTML={{ __html: other_information }}
                  />
                )}
                <div className="flex-container align-middle align-justify">
                  <p>{t('phoneNumber')}</p>
                  <p>{replacePhoneNumber(phone_number)}</p>
                </div>
                {!!email && (
                  <div className="flex-container align-middle align-justify">
                    <p>{t('email')}</p>
                    <p>{email}</p>
                  </div>
                )}
                <div className="flex-container align-middle align-justify">
                  <p>{t('addressLabel')}</p>
                  <p>{address}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Services />
    </section>
  )
}

export const LocationDetails: React.FC<ILocationDetailsProps> = props => (
  <APIProvider apiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY as string}>
    <LocationDetailsView {...props} />
  </APIProvider>
)
